import axiosInstance from '@/utils/api.js'

var state = {
  streets: []
}

var getters = {
  STREETS: (state) => {
    return state.streets
  }
}

var mutations = {
  SET_STREETS: (state, payload) => {
    state.streets = payload
  }
}

var actions = {
  GET_STREETS: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/streets')
    if (result.status === 200) {
      context.commit('SET_STREETS', result.data)
    }
  },
  CREATE_STREETS: (context, payload) => {
    return axiosInstance.post('/referencebooks/streets', payload)
  },
  UPDATE_STREETS: (context, payload) => {
    return axiosInstance.put('/referencebooks/streets', payload)
  },
  DELETE_STREETS: (context, payload) => {
    return axiosInstance.delete('/referencebooks/streets?street_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/referencebooks/streets.js